import { useSelector } from 'react-redux';
import { createDialogStateSelector } from 'modules/Core/reducers';
import { DialogState } from 'modules/Common/types';

export default (dialogName: string): DialogState => {
  return useSelector(state => createDialogStateSelector(`${dialogName}_DIALOG`)(state));
};
